import React from "react"

import AppLayoutTop from "@modules/framework/AppLayoutTop"
import AppLayoutHeader from "@modules/framework/AppLayoutHeader"
import AppLayoutMain from "@modules/framework/AppLayoutMain"
import ScrollToTopLink from "@modules/framework/ScrollToTopLink"
import AppHeader from "@modules/framework/AppHeader"
import Home from "../Home"

const HomePage = () => {
    return (
        <AppLayoutTop>
            <AppLayoutHeader>
                <ScrollToTopLink>
                    <AppHeader
                        title="Hjem"
                        isHomePage
                        isBackButtonHidden
                        isTrumfCardVisible
                    />
                </ScrollToTopLink>
            </AppLayoutHeader>
            <AppLayoutMain>
                <Home />
            </AppLayoutMain>
        </AppLayoutTop>
    )
}

export default HomePage
